module.exports = __webpack_public_path__ + "img/tech_service_menue_2.94dfd4ea.png";